import React from 'react';
import Link from 'react-router';

import { PrimaryButton } from '../Ui';
import Tooltip from '../common/components/form/Tooltip';

import SafetyIndexScore from './SafetyIndexScore';

import T from '../common/translation';

const A2P_IMGS = [
	require('../../assets/a2p-1.png'),
	require('../../assets/a2p-2.png'),
	require('../../assets/a2p-3.png')
];

export default function CardOffer(props) {
	const {
		product_line_id,
		name,
		delay,
		safety_index,
		en1303,
		img,
		long_description,
		documentation
	} = props.product_line;
	const { amount, brand, onClick } = props;
	const domain = require('Config').domain;
	const protocol = require('Config').protocol;

	const imgURL = img;

	const a2pLevel = props.product_line.a2p;
	const a2pImg = a2pLevel && A2P_IMGS[a2pLevel - 1];

	const noEn1303 = !en1303 || en1303 === '-';
	const labelEn1303 = noEn1303 ? 'Non' : en1303;

	let label_is_protected = '';
	if (props.product_line.is_protected) {
		if (props.product_line.patent) {
			if (props.product_line.patent == 1) {
				label_is_protected += 'Protection par brevet. ';
			} else {
				label_is_protected +=
					"Brevet jusqu'en " + props.product_line.patent + '. ';
			}
		}
		if (props.product_line.brand_deposit) {
			label_is_protected += 'Dépôt de marque illimité dans le temps. ';
		}
	} else {
		label_is_protected = ' Non ';
	}

	return (
		<div className="offer-card" key={product_line_id}>
			<div className="offer-card__header">
				<img className="offer-card__img" src={imgURL} />
				{a2pLevel && <img className="offer-card__a2p" src={a2pImg} />}
			</div>
			<div className="offer-card__name">{name}</div>

			<div className="offer-card__line">
				<div className="offer-card__line-title">{T('brand')}</div>
				<span>
					<b>{brand.name}</b>
				</span>
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">{T('description')}</div>
				<span>{long_description}</span>
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">
					{T('delay')}
					<Tooltip top left>
						Délai moyen constaté pouvant varier en fonction du
						nombre de cylindres et du fonctionnement du projet
					</Tooltip>
				</div>
				<span>{delay}</span> {T('days')}
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">Prix</div>
				<span className="offer-card__price">{amount}€ net H.T.</span>
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">
					{T('safety index')}
					<Tooltip top left>
						Pour faciliter votre choix, Legallais a créé un indice
						de sécurité prenant en compte 11 critères dont : - La
						présence de protection : anticasse, antibumping,
						anticrochetage, antiperçage - La classification des
						cylindres en fonction de la norme NF EN 1303:V2005 - Le
						nombre de goupilles de verrouillage - Le niveau de
						protection de la clé : brevet, dépôt de marque - L
						ergonomie et le type de clé (avec mobile, etc.) Nous
						distinguons ainsi 5 niveaux de sécurité allant du
						cylindre standard basique au cylindre de très haute
						sûreté.
					</Tooltip>
				</div>
				<SafetyIndexScore index={safety_index} />
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">
					{T('EN1303 norme')}
					<Tooltip top left>
						Certains fabricants testent, par une démarche
						volontaire, l’usage et l’application de cylindres
						mécaniques dans les serrures pour bâtiments selon la
						norme EN1303.
						<br />
						Elle est basée sur un modèle de classification à 8
						chiffres correspondant à des critères tels que leur
						endurance, le niveau de sécurité de la clé et la
						résistance aux attaques.
					</Tooltip>
				</div>
				<p>{labelEn1303}</p>
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">
					{T('protection')}
					<Tooltip top left>
						Les clés peuvent être protégées contre toute
						reproduction illicite.
						<br />
						Seule l'usine d'origine est habilitée à les reproduire
						sur présentation d’une carte de propriété.
						<br />
						Il existe 2 types de protection : <br />- la protection
						par brevet, limitée à un nombre d’années
						<br />- la protection par dépôt de marque (copyright)
						qui protège la clé à vie.
					</Tooltip>
				</div>
				<p>{label_is_protected}</p>
			</div>
			<div className="offer-card__line">
				<div className="offer-card__line-title">Documentation</div>
				{documentation.length > 0 ? (
					<ul>
						{documentation.map(doc => (
							<li>
								<a
									className="link"
									href={doc.url}
									target="_blank"
								>
									{doc.title}
								</a>
							</li>
						))}
					</ul>
				) : (
					<div>Pas de documentation</div>
				)}
			</div>

			<div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
				<PrimaryButton
					block
					fillWidth
					loading={props.loading}
					onClick={onClick}
				>
					Choisir
				</PrimaryButton>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/js/offer/OfferCard.js